import { atom, atomFamily, selector, selectorFamily } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";
import contentsPresetEffect from "./effect/ContentsPresetEffect";
import { disabledContentsWithID } from "./DisabledContentsState";

export const MAP_ID_TILEMAP = 'MAP_ID_TILEMAP';
export const MAP_ID_LONLAT = 'MAP_ID_LONLAT';
export const MAP_ID_FIR = 'MAP_ID_FIR';
export const MAP_ID_AIRPORT = 'MAP_ID_AIRPORT';
export const MAP_ID_FIX = 'MAP_ID_FIX';
export const MAP_ID_AIRWAY = 'MAP_ID_AIRWAY';
export const MAP_ID_NAVAIDS = 'MAP_ID_NAVAIDS';
export const MAP_ID_FLIGHTPLAN = 'MAP_ID_FLIGHTPLAN';
export const MAP_ID_FLIGHTPLAN_LIST = 'MAP_ID_FLIGHTPLAN_LIST';
export const MAP_ID_COASTLINE = 'MAP_ID_COASTLINE';
export const MAP_ID_ELEVATION = 'MAP_ID_ELEVATION';
export const MAP_ID_COPILOT = "MAP_ID_COPILOT";
export const MAP_ID_FLIGHT_HISTORY = "MAP_ID_FLIGHT_HISTORY";
export const MAP_ID_CUSTOM_POINT_AREA = 'MAP_ID_CUSTOM_POINT_AREA';
export const MAP_ID_CONTROL_ZONE = 'MAP_ID_CONTROL_ZONE';
export const MAP_ID_INFORMATION_ZONE = 'MAP_ID_INFORMATION_ZONE';
export const MAP_ID_TRAINING_AIRSPACE = 'MAP_ID_TRAINING_AIRSPACE';
export const MAP_ID_POWER_LINES = 'MAP_ID_POWER_LINES';
export const MAP_ID_POWER_PYLONS = 'MAP_ID_POWER_PYLONS';
export const MAP_ID_FORECAST_REGION = 'MAP_ID_FORECAST_REGION';

const mapContentsVisibleFamily = atomFamily({
  key: 'mapContentsVisibleFamily',
  default: selectorFamily({
    key: 'mapContentsVisibleFamilySelector',
    get: param => ({get}) => {
      const state = get(disabledContentsWithID(param));
      const disabled = typeof state === 'boolean' ? state : Object.values(state).filter(v=>v).length === Object.keys(state).length;
      return disabled ? false : getCustomerSettings(`layerConfig.${param}.checked`) || false;
    }
  }),
  effects: param => [
    contentsPresetEffect(param)
  ]
});

export const selectedMapContentsList = atom({
  key: 'selectedMapContentsList',
  default: selector({
    key: 'selectedMapContentsListSelector',
    get: () => {
      const layerConfig = getCustomerSettings('layerConfig');
      const menuOtherOrder = getCustomerSettings('menuOtherOrder');
      const list = [];
      menuOtherOrder.forEach(other => {
        if(layerConfig[other].checked) {
          list.push(other);
        }
      });
      return list;
    }
  })


});

export const mapContentsVisibleWithID = selectorFamily({
  key: 'mapContentsVisibleWithID',

  get: (id) => ({get}) => {
    return get(mapContentsVisibleFamily(id));
  },

  set: (id) => ({set, get}, newValue) => {
    set(mapContentsVisibleFamily(id), newValue);
    const oldList = get(selectedMapContentsList);
    let newList;
    if (newValue) {
      if (oldList.includes(id)) {
        return;
      }
      newList = [...oldList, id];
    } else {
      const index = oldList.findIndex(_id => _id === id);
      if (index === -1) return;
      newList = [...oldList.slice(0, index), ...oldList.slice(index + 1)]
    }
    set(selectedMapContentsList, newList);
  }
});

export const toggleMapContentsVisibleWithID = selectorFamily({
  key: 'toggleMapContentsVisibleWithID',
  set: (id) => ({set, get}) => {
    const visible = get(mapContentsVisibleWithID(id))
    set(mapContentsVisibleWithID(id), !visible);
  }
});

export const isMapContents = (id) => {
  return [
    MAP_ID_TILEMAP,
    MAP_ID_LONLAT,
    MAP_ID_FIR,
    MAP_ID_AIRPORT,
    MAP_ID_FIX,
    MAP_ID_AIRWAY,
    MAP_ID_NAVAIDS,
    MAP_ID_FLIGHTPLAN,
    MAP_ID_FLIGHTPLAN_LIST,
    MAP_ID_COASTLINE,
    MAP_ID_ELEVATION,
    MAP_ID_COPILOT,
    MAP_ID_FLIGHT_HISTORY,
    MAP_ID_CUSTOM_POINT_AREA,
    MAP_ID_CONTROL_ZONE,
    MAP_ID_INFORMATION_ZONE,
    MAP_ID_TRAINING_AIRSPACE,
    MAP_ID_POWER_LINES,
    MAP_ID_POWER_PYLONS,
    MAP_ID_FORECAST_REGION
  ].includes(id);
};

